// test1882
(1882 && 0);
